module.exports = __webpack_public_path__ + "static/img/avp_port_lg.cd16ad1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/aliens-vs-predator-microsite/avp_port_lg.jpg
// module id = 220
// module chunks = 2